// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"52a7159e","983":"947ccca7"}[chunkId] + ".chunk.css";
};